// La division de un torneo de la red: una categoria convocada + un genero (Femenil,
// Varonil o Mixto). Un torneo puede convocar U14 en los tres generos y cada uno compite
// aparte. Su llave es convocatoria_id (la fila de torneos_categorias). Decision del
// duenio, 2026-10-05: el genero vive en la convocatoria, no en la categoria.
//
// COPIA IDENTICA en myklubb-torneos/src/lib/division.js, con la misma prueba: si tocas
// una, toca la otra.

export const RAMAS = ['Femenil', 'Varonil', 'Mixto']

const sinAcentos = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')

// Gemela de public._rama_normalizada: 'varonil', ' Femenil ' -> 'Varonil', 'Femenil'.
// No quita acentos, igual que la base. Cualquier otra cosa (vacio, 'Masculino') -> null.
export const normalizarRama = (valor) => {
  const v = String(valor || '').trim().toLowerCase()
  return RAMAS.find((r) => r.toLowerCase() === v) || null
}

// ¿El nombre de la categoria ya dice el genero, como palabra? ("U16 Varonil" + Varonil)
export const nombreIncluyeRama = (nombre, rama) => {
  const r = normalizarRama(rama)
  if (!r) return false
  const palabras = sinAcentos(nombre).toLowerCase().split(/[^a-z0-9]+/)
  return palabras.includes(r.toLowerCase())
}

const conRama = (separador) => ({ nombre, rama } = {}) => {
  const base = String(nombre || '').trim() || 'Sin categoría'
  const r = normalizarRama(rama)
  if (!r || nombreIncluyeRama(base, r)) return base
  return `${base}${separador}${r}`
}

// "U14 · Femenil". Si el nombre ya trae el genero no lo repite; sin genero, el nombre.
export const etiquetaDivision = conRama(' · ')

// Igual, con espacio: de aqui salen las etiquetas cortas del rol ("U14 FEMENIL").
export const nombreConRama = conRama(' ')

// Llave de la division de una fila (rol, inscripcion, convocatoria). Las filas sin
// division (viejas o de torneos internos) caen a su categoria.
export const idDivision = (fila) => fila?.convocatoria_id || fila?.categoria_id || null

// 1 a 1: el grupo entra solo a la division de su mismo genero. Mixto solo con Mixto.
export const grupoEntraADivision = (grupoRama, divisionRama) => {
  const g = normalizarRama(grupoRama)
  return Boolean(g) && g === normalizarRama(divisionRama)
}

// Para el selector de grupos al inscribir en la red: los que entran, los que no tienen
// genero (se avisan: hay que asignarselo en el grupo) y los de otro genero (no se ofrecen).
export const separarGruposPorDivision = (grupos, divisionRama) => {
  const res = { compatibles: [], sinGenero: [], otroGenero: [] }
  for (const g of grupos || []) {
    if (!normalizarRama(g.rama)) res.sinGenero.push(g)
    else if (grupoEntraADivision(g.rama, divisionRama)) res.compatibles.push(g)
    else res.otroGenero.push(g)
  }
  return res
}

// Las divisiones donde el club tiene equipos: de las filas convocadas (una por division),
// las que aparecen en sus inscripciones. Una inscripcion vieja sin division cuenta para
// todas las divisiones de su categoria.
export const divisionesDelClub = (convocadas, inscripciones) => {
  const ins = inscripciones || []
  const porDivision = new Set(ins.map((i) => i.convocatoria_id).filter(Boolean))
  const porCategoria = new Set(ins.filter((i) => !i.convocatoria_id).map((i) => i.categoria_id).filter(Boolean))
  return (convocadas || [])
    .filter((c) => porDivision.has(c.convocatoria_id) || porCategoria.has(c.categoria_id))
    .map((c) => ({ id: idDivision(c), categoriaId: c.categoria_id, nombre: etiquetaDivision(c) }))
}
